import * as ds from '#core/design-system'

export default {
  ds,
  toasterDismissDelay: 6000
}
